import Axios from "axios";
import {
    SET_CHEQUE_BOOK_LIST,
    UNSET_CHEQUE_BOOK_LIST,
    SET_CHEQUE_LIST,
    UNSET_CHEQUE_LIST,
    SET_EDITING_CHEQUE_BOOK_LIST,
    UNSET_EDITING_CHEQUE_BOOK_LIST,
} from "@/store/mutation-types";
import { 
    getChequeBookList, 
    getChequeList,
    getChequeById,
    getChequeBookById,
    saveChequeBook,
    updateChequeBook,
} from "@/store/api";

// initial state
const state = {
    getChequeBookList: [],
    getChequeList: [],
    getEditingChequeBook: {},
};

const getters = {
    getChequeBookList(state) {
        return state.getChequeBookList;
    },
    getChequeList(state) {
        return state.getChequeList;
    },
    getEditingChequeBook(state) {
        return state.getEditingChequeBook;
    },
};

const mutations = {
    [SET_CHEQUE_BOOK_LIST](state, data) {
        state.getChequeBookList = data;
    },
    [UNSET_CHEQUE_BOOK_LIST](state) {
        state.getChequeBookList = [];
    },
    [SET_CHEQUE_LIST](state, data) {
        state.getChequeList = data;
    },
    [UNSET_CHEQUE_LIST](state) {
        state.getChequeList = [];
    },
    [SET_EDITING_CHEQUE_BOOK_LIST](state, data) {
        state.getEditingChequeBook = data;
    },
    [UNSET_EDITING_CHEQUE_BOOK_LIST](state) {
        state.getEditingChequeBook = {};
    },
};

const actions = {
    saveChequeBook({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveChequeBook, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateChequeBook({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.put(`${updateChequeBook}/${data.checkBook_id}`, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getChequeBookList({ commit }) {
        return new Promise((resolve, reject) => {
        Axios.get(getChequeBookList)
            .then(function (response) {
            commit('SET_CHEQUE_BOOK_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_CHEQUE_BOOK_LIST');
            reject(error);
            });
        });
    },

    getChequeList({ commit }, data) {
        return new Promise((resolve, reject) => {
        Axios.get(getChequeList, { params: data })
            .then(function (response) {
            commit('SET_CHEQUE_LIST', response.data.data);
            resolve(response);
            })
            .catch(function (error) {
            commit('UNSET_CHEQUE_LIST');
            reject(error);
            });
        });
    },

    getChequeBookById({ commit }, data) {
        const getchequeBookRecordById = `${getChequeBookById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getchequeBookRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
    getChequeById({ commit }, data) {
        const getchequeRecordById = `${getChequeById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getchequeRecordById)
                    .then((response) => {
                    resolve(response.data.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

